<template>
    <div class="pa-2">
        <v-row v-if="ruta == 'dashboard'">
            <v-col cols="12" md="12">
                <v-skeleton-loader type="card-heading"></v-skeleton-loader>
            </v-col>
            <v-col cols="12" md="5">
                <v-skeleton-loader type="card-heading, card"></v-skeleton-loader>
            </v-col>
            <v-col cols="12" md="7">
                <v-skeleton-loader type="card-heading, card"></v-skeleton-loader>
                <v-skeleton-loader type="card-heading, card"></v-skeleton-loader>
            </v-col>
        </v-row>
        <v-row v-if="ruta == 'resumen'">
            <v-col cols="12" md="6">
                <v-skeleton-loader :type="tipo"></v-skeleton-loader>
            </v-col>
            <v-col cols="12" md="6">
                <v-skeleton-loader :type="tipo"></v-skeleton-loader>
            </v-col>
        </v-row>
        <v-row v-if="ruta == 'niveles'">
            <v-col cols="12" md="12">
                <v-skeleton-loader type="card-heading"></v-skeleton-loader>
            </v-col>
            <v-col cols="12" md="12">
                <v-skeleton-loader type="card, card-heading"></v-skeleton-loader>
            </v-col>
        </v-row>
        <v-row v-if="ruta == 'turnos'">
            <v-col cols="12" md="12">
                <v-skeleton-loader :type="tipo"></v-skeleton-loader>
            </v-col>
        </v-row>
        <v-row v-if="ruta == 'tramites'">
            <v-col cols="12" md="12">
                <v-skeleton-loader :type="tipo"></v-skeleton-loader>
            </v-col>
        </v-row>
        <v-row v-if="ruta == 'aportes' || ruta == 'haberes'">
            <v-col cols="12" md="12">
                <v-skeleton-loader :type="tipo"></v-skeleton-loader>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    // Vuetify components provide
    // a theme variable that is
    // used to determine dark
    inject: {
        theme: {
            default: { isDark: false },
        },
    },

    props: ['tipo', 'ruta']
}
</script>